export const AI_WORKFLOW_STORAGE_KEY = 'tolink_aiWorkflowUrl';
export const DEFAULT_AI_WORKFLOW_URL = 'https://n8n.mdclaw.ai/webhook/df1c80d4-25b9-4ba9-b407-3b49670369bd';

export function getAIWorkflowUrl(): string {
    try {
        return (localStorage.getItem(AI_WORKFLOW_STORAGE_KEY) || '').trim();
    } catch {
        return '';
    }
}

export function resolveAIWorkflowUrl(): string {
    const stored = getAIWorkflowUrl();
    return /^https?:\/\//i.test(stored) ? stored : DEFAULT_AI_WORKFLOW_URL;
}

export function setAIWorkflowUrl(url: unknown): string {
    const value = typeof url === 'string' ? url.trim() : '';
    try {
        if (value) localStorage.setItem(AI_WORKFLOW_STORAGE_KEY, value);
        else localStorage.removeItem(AI_WORKFLOW_STORAGE_KEY);
    } catch {
        // The caller still receives the normalized value when storage is unavailable.
    }
    return value;
}
